@file:OptIn(InternalResourceApi::class)

package retroguide.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/retroguide.app.shared.generated.resources/"

@delegate:ResourceContentHash(1_365_650_047)
internal val Res.string.error_rate_limited: StringResource by lazy {
      StringResource("string:error_rate_limited", "error_rate_limited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5315, 86),
      ))
    }

@delegate:ResourceContentHash(-1_548_239_026)
internal val Res.string.error_session_not_found: StringResource by lazy {
      StringResource("string:error_session_not_found", "error_session_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5402, 75),
      ))
    }

@delegate:ResourceContentHash(204_038_655)
internal val Res.string.finish_retro_action: StringResource by lazy {
      StringResource("string:finish_retro_action", "finish_retro_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5478, 47),
      ))
    }

@delegate:ResourceContentHash(-756_455_040)
internal val Res.string.invitation_link_label: StringResource by lazy {
      StringResource("string:invitation_link_label", "invitation_link_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5526, 49),
      ))
    }

@delegate:ResourceContentHash(838_429_470)
internal val Res.string.invitation_link_supporting_text: StringResource by lazy {
      StringResource("string:invitation_link_supporting_text", "invitation_link_supporting_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5576, 95),
      ))
    }

@delegate:ResourceContentHash(-1_939_926_580)
internal val Res.string.invitation_share_action: StringResource by lazy {
      StringResource("string:invitation_share_action", "invitation_share_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5672, 55),
      ))
    }

@delegate:ResourceContentHash(-1_443_293_860)
internal val Res.string.invitation_share_code_option: StringResource by lazy {
      StringResource("string:invitation_share_code_option", "invitation_share_code_option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5728, 60),
      ))
    }

@delegate:ResourceContentHash(-756_455_040)
internal val Res.string.invitation_share_link_option: StringResource by lazy {
      StringResource("string:invitation_share_link_option", "invitation_share_link_option", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5789, 56),
      ))
    }

@delegate:ResourceContentHash(-698_755_039)
internal val Res.string.invitation_share_title: StringResource by lazy {
      StringResource("string:invitation_share_title", "invitation_share_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5846, 62),
      ))
    }

@delegate:ResourceContentHash(2_047_907_393)
internal val Res.string.join_action: StringResource by lazy {
      StringResource("string:join_action", "join_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5909, 39),
      ))
    }

@delegate:ResourceContentHash(23_507_649)
internal val Res.string.join_hint: StringResource by lazy {
      StringResource("string:join_hint", "join_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5949, 93),
      ))
    }

@delegate:ResourceContentHash(760_007_770)
internal val Res.string.join_loading: StringResource by lazy {
      StringResource("string:join_loading", "join_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6043, 64),
      ))
    }

@delegate:ResourceContentHash(1_625_227_178)
internal val Res.string.join_subtitle: StringResource by lazy {
      StringResource("string:join_subtitle", "join_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6108, 133),
      ))
    }

@delegate:ResourceContentHash(-1_599_238_629)
internal val Res.string.join_title: StringResource by lazy {
      StringResource("string:join_title", "join_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6242, 34),
      ))
    }

@delegate:ResourceContentHash(-971_339_609)
internal val Res.string.leave_action: StringResource by lazy {
      StringResource("string:leave_action", "leave_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6277, 40),
      ))
    }

@delegate:ResourceContentHash(-1_962_059_997)
internal val Res.string.lobby_connecting: StringResource by lazy {
      StringResource("string:lobby_connecting", "lobby_connecting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6318, 56),
      ))
    }

@delegate:ResourceContentHash(1_213_044_815)
internal val Res.string.lobby_waiting: StringResource by lazy {
      StringResource("string:lobby_waiting", "lobby_waiting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6375, 81),
      ))
    }

@delegate:ResourceContentHash(1_131_752_451)
internal val Res.string.moderator_badge: StringResource by lazy {
      StringResource("string:moderator_badge", "moderator_badge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6457, 39),
      ))
    }

@delegate:ResourceContentHash(-1_043_959_718)
internal val Res.string.moderator_lobby_title: StringResource by lazy {
      StringResource("string:moderator_lobby_title", "moderator_lobby_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6497, 49),
      ))
    }

@delegate:ResourceContentHash(-1_819_583_645)
internal val Res.string.moderator_question_title: StringResource by lazy {
      StringResource("string:moderator_question_title", "moderator_question_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6547, 52),
      ))
    }

@delegate:ResourceContentHash(-1_223_801_879)
internal val Res.string.moderator_summary_title: StringResource by lazy {
      StringResource("string:moderator_summary_title", "moderator_summary_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6600, 55),
      ))
    }

@delegate:ResourceContentHash(1_010_122_375)
internal val Res.string.name_option_occupied: StringResource by lazy {
      StringResource("string:name_option_occupied", "name_option_occupied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6656, 48),
      ))
    }

@delegate:ResourceContentHash(1_028_818_079)
internal val Res.string.name_options_loading: StringResource by lazy {
      StringResource("string:name_options_loading", "name_options_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6705, 68),
      ))
    }

@delegate:ResourceContentHash(1_555_556_207)
internal val Res.string.name_selection_heading: StringResource by lazy {
      StringResource("string:name_selection_heading", "name_selection_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6774, 58),
      ))
    }

@delegate:ResourceContentHash(-1_078_342_443)
internal val Res.string.next_question_action: StringResource by lazy {
      StringResource("string:next_question_action", "next_question_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6833, 48),
      ))
    }

@delegate:ResourceContentHash(-474_899_390)
internal val Res.string.no_answer_action: StringResource by lazy {
      StringResource("string:no_answer_action", "no_answer_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6882, 44),
      ))
    }

@delegate:ResourceContentHash(-474_899_390)
internal val Res.string.no_answer_status: StringResource by lazy {
      StringResource("string:no_answer_status", "no_answer_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6927, 44),
      ))
    }

@delegate:ResourceContentHash(-474_892_793)
internal val Res.string.no_answers: StringResource by lazy {
      StringResource("string:no_answers", "no_answers", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6972, 38),
      ))
    }

@delegate:ResourceContentHash(-1_481_078_299)
internal val Res.string.no_more_answers_action: StringResource by lazy {
      StringResource("string:no_more_answers_action", "no_more_answers_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7011, 62),
      ))
    }

@delegate:ResourceContentHash(-1_481_078_299)
internal val Res.string.no_more_answers_status: StringResource by lazy {
      StringResource("string:no_more_answers_status", "no_more_answers_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7074, 62),
      ))
    }

@delegate:ResourceContentHash(177_777_719)
internal val Res.string.open_status: StringResource by lazy {
      StringResource("string:open_status", "open_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7137, 27),
      ))
    }

@delegate:ResourceContentHash(-620_108_675)
internal val Res.string.own_answers_title: StringResource by lazy {
      StringResource("string:own_answers_title", "own_answers_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7165, 45),
      ))
    }

@delegate:ResourceContentHash(843_115_939)
internal val Res.string.participant_answer_count: StringResource by lazy {
      StringResource("string:participant_answer_count", "participant_answer_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7211, 52),
      ))
    }

@delegate:ResourceContentHash(-1_107_301_635)
internal val Res.string.participant_count: StringResource by lazy {
      StringResource("string:participant_count", "participant_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7264, 49),
      ))
    }

@delegate:ResourceContentHash(-312_173_086)
internal val Res.string.participant_lobby_title: StringResource by lazy {
      StringResource("string:participant_lobby_title", "participant_lobby_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7314, 51),
      ))
    }

@delegate:ResourceContentHash(382_708_931)
internal val Res.string.participant_names_label: StringResource by lazy {
      StringResource("string:participant_names_label", "participant_names_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7366, 63),
      ))
    }

@delegate:ResourceContentHash(573_557_725)
internal val Res.string.participant_names_supporting_text: StringResource by lazy {
      StringResource("string:participant_names_supporting_text", "participant_names_supporting_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7430, 141),
      ))
    }

@delegate:ResourceContentHash(116_158_438)
internal val Res.string.participant_question_title: StringResource by lazy {
      StringResource("string:participant_question_title", "participant_question_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7572, 50),
      ))
    }

@delegate:ResourceContentHash(1_175_824_878)
internal val Res.string.question_answer_visibility_label: StringResource by lazy {
      StringResource("string:question_answer_visibility_label", "question_answer_visibility_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7623, 96),
      ))
    }

@delegate:ResourceContentHash(2_010_148_891)
internal val Res.string.question_label: StringResource by lazy {
      StringResource("string:question_label", "question_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7720, 38),
      ))
    }

@delegate:ResourceContentHash(1_782_474_641)
internal val Res.string.question_placeholder: StringResource by lazy {
      StringResource("string:question_placeholder", "question_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7759, 76),
      ))
    }

@delegate:ResourceContentHash(-901_357_693)
internal val Res.string.question_progress: StringResource by lazy {
      StringResource("string:question_progress", "question_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7836, 53),
      ))
    }

@delegate:ResourceContentHash(597_769_642)
internal val Res.string.question_timer_enabled_label: StringResource by lazy {
      StringResource("string:question_timer_enabled_label", "question_timer_enabled_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7890, 52),
      ))
    }

@delegate:ResourceContentHash(-64_184_115)
internal val Res.string.question_timer_label: StringResource by lazy {
      StringResource("string:question_timer_label", "question_timer_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7943, 48),
      ))
    }

@delegate:ResourceContentHash(1_168_165_631)
internal val Res.string.question_timer_supporting_text: StringResource by lazy {
      StringResource("string:question_timer_supporting_text", "question_timer_supporting_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7992, 62),
      ))
    }

@delegate:ResourceContentHash(42_449_820)
internal val Res.string.question_widget_action_items: StringResource by lazy {
      StringResource("string:question_widget_action_items", "question_widget_action_items", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8055, 52),
      ))
    }

@delegate:ResourceContentHash(1_189_506_698)
internal val Res.string.question_widget_battery: StringResource by lazy {
      StringResource("string:question_widget_battery", "question_widget_battery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8108, 43),
      ))
    }

@delegate:ResourceContentHash(66_551_863)
internal val Res.string.question_widget_daki: StringResource by lazy {
      StringResource("string:question_widget_daki", "question_widget_daki", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8152, 36),
      ))
    }

@delegate:ResourceContentHash(-1_255_440_037)
internal val Res.string.question_widget_dot_voting: StringResource by lazy {
      StringResource("string:question_widget_dot_voting", "question_widget_dot_voting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8189, 50),
      ))
    }

@delegate:ResourceContentHash(2_393_757)
internal val Res.string.question_widget_four_l: StringResource by lazy {
      StringResource("string:question_widget_four_l", "question_widget_four_l", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8240, 34),
      ))
    }

@delegate:ResourceContentHash(-963_718_831)
internal val Res.string.question_widget_hot_air_balloon: StringResource by lazy {
      StringResource("string:question_widget_hot_air_balloon", "question_widget_hot_air_balloon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8275, 59),
      ))
    }

@delegate:ResourceContentHash(352_607_393)
internal val Res.string.question_widget_kalm: StringResource by lazy {
      StringResource("string:question_widget_kalm", "question_widget_kalm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8335, 36),
      ))
    }

@delegate:ResourceContentHash(-1_324_274_110)
internal val Res.string.question_widget_label: StringResource by lazy {
      StringResource("string:question_widget_label", "question_widget_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8372, 45),
      ))
    }

@delegate:ResourceContentHash(110_457_480)
internal val Res.string.question_widget_mad_sad_glad: StringResource by lazy {
      StringResource("string:question_widget_mad_sad_glad", "question_widget_mad_sad_glad", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8418, 60),
      ))
    }

@delegate:ResourceContentHash(1_549_808)
internal val Res.string.question_widget_roti: StringResource by lazy {
      StringResource("string:question_widget_roti", "question_widget_roti", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8479, 36),
      ))
    }

@delegate:ResourceContentHash(-1_159_926_742)
internal val Res.string.question_widget_sailboat: StringResource by lazy {
      StringResource("string:question_widget_sailboat", "question_widget_sailboat", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8516, 44),
      ))
    }

@delegate:ResourceContentHash(-151_568_802)
internal val Res.string.question_widget_speedcar: StringResource by lazy {
      StringResource("string:question_widget_speedcar", "question_widget_speedcar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8561, 44),
      ))
    }

@delegate:ResourceContentHash(-2_010_006_256)
internal val Res.string.question_widget_starfish: StringResource by lazy {
      StringResource("string:question_widget_starfish", "question_widget_starfish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8606, 44),
      ))
    }

@delegate:ResourceContentHash(777_617_134)
internal val Res.string.question_widget_team_radar: StringResource by lazy {
      StringResource("string:question_widget_team_radar", "question_widget_team_radar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8651, 50),
      ))
    }

@delegate:ResourceContentHash(-1_194_722_114)
internal val Res.string.question_widget_text: StringResource by lazy {
      StringResource("string:question_widget_text", "question_widget_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8702, 40),
      ))
    }

@delegate:ResourceContentHash(-802_136_644)
internal val Res.string.question_widget_weather: StringResource by lazy {
      StringResource("string:question_widget_weather", "question_widget_weather", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8743, 39),
      ))
    }

@delegate:ResourceContentHash(-1_689_208_290)
internal val Res.string.radar_answer_count: StringResource by lazy {
      StringResource("string:radar_answer_count", "radar_answer_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8783, 74),
      ))
    }

@delegate:ResourceContentHash(-1_552_218_793)
internal val Res.string.radar_answer_prompt: StringResource by lazy {
      StringResource("string:radar_answer_prompt", "radar_answer_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8858, 99),
      ))
    }

@delegate:ResourceContentHash(922_766_182)
internal val Res.string.radar_answer_single: StringResource by lazy {
      StringResource("string:radar_answer_single", "radar_answer_single", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8958, 71),
      ))
    }

@delegate:ResourceContentHash(687_167_259)
internal val Res.string.radar_collaboration: StringResource by lazy {
      StringResource("string:radar_collaboration", "radar_collaboration", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9099, 47),
      ))
    }

@delegate:ResourceContentHash(892_422_971)
internal val Res.string.radar_collaboration_hint: StringResource by lazy {
      StringResource("string:radar_collaboration_hint", "radar_collaboration_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9030, 68),
      ))
    }

@delegate:ResourceContentHash(870_389_240)
internal val Res.string.radar_focus: StringResource by lazy {
      StringResource("string:radar_focus", "radar_focus", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9220, 27),
      ))
    }

@delegate:ResourceContentHash(-1_043_187_743)
internal val Res.string.radar_focus_hint: StringResource by lazy {
      StringResource("string:radar_focus_hint", "radar_focus_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9147, 72),
      ))
    }

@delegate:ResourceContentHash(2_117_205_895)
internal val Res.string.radar_fun: StringResource by lazy {
      StringResource("string:radar_fun", "radar_fun", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9315, 25),
      ))
    }

@delegate:ResourceContentHash(137_705_257)
internal val Res.string.radar_fun_hint: StringResource by lazy {
      StringResource("string:radar_fun_hint", "radar_fun_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9248, 66),
      ))
    }

@delegate:ResourceContentHash(1_532_312_064)
internal val Res.string.radar_learning: StringResource by lazy {
      StringResource("string:radar_learning", "radar_learning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9401, 30),
      ))
    }

@delegate:ResourceContentHash(873_107_384)
internal val Res.string.radar_learning_hint: StringResource by lazy {
      StringResource("string:radar_learning_hint", "radar_learning_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9341, 59),
      ))
    }

@delegate:ResourceContentHash(877_054_043)
internal val Res.string.radar_quality: StringResource by lazy {
      StringResource("string:radar_quality", "radar_quality", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9511, 33),
      ))
    }

@delegate:ResourceContentHash(583_353_550)
internal val Res.string.radar_quality_hint: StringResource by lazy {
      StringResource("string:radar_quality_hint", "radar_quality_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9432, 78),
      ))
    }

@delegate:ResourceContentHash(-627_886_550)
internal val Res.string.radar_score_description: StringResource by lazy {
      StringResource("string:radar_score_description", "radar_score_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9545, 55),
      ))
    }

@delegate:ResourceContentHash(718_340_120)
internal val Res.string.radar_speed: StringResource by lazy {
      StringResource("string:radar_speed", "radar_speed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9654, 27),
      ))
    }

@delegate:ResourceContentHash(-1_572_449_577)
internal val Res.string.radar_speed_hint: StringResource by lazy {
      StringResource("string:radar_speed_hint", "radar_speed_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9601, 52),
      ))
    }

@delegate:ResourceContentHash(1_158_785_586)
internal val Res.string.registered_participants: StringResource by lazy {
      StringResource("string:registered_participants", "registered_participants", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9682, 71),
      ))
    }

@delegate:ResourceContentHash(-702_043_244)
internal val Res.string.retro_finished: StringResource by lazy {
      StringResource("string:retro_finished", "retro_finished", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9754, 54),
      ))
    }

@delegate:ResourceContentHash(-946_341_257)
internal val Res.string.reveal_answers_action: StringResource by lazy {
      StringResource("string:reveal_answers_action", "reveal_answers_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9809, 53),
      ))
    }

@delegate:ResourceContentHash(-1_174_386_191)
internal val Res.string.revealed_answers_title: StringResource by lazy {
      StringResource("string:revealed_answers_title", "revealed_answers_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9863, 42),
      ))
    }

@delegate:ResourceContentHash(-292_575_490)
internal val Res.string.roti_1: StringResource by lazy {
      StringResource("string:roti_1", "roti_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9906, 30),
      ))
    }

@delegate:ResourceContentHash(-738_487_349)
internal val Res.string.roti_2: StringResource by lazy {
      StringResource("string:roti_2", "roti_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9937, 22),
      ))
    }

@delegate:ResourceContentHash(917_840_254)
internal val Res.string.roti_3: StringResource by lazy {
      StringResource("string:roti_3", "roti_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9960, 22),
      ))
    }

@delegate:ResourceContentHash(2_494_587)
internal val Res.string.roti_4: StringResource by lazy {
      StringResource("string:roti_4", "roti_4", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9983, 18),
      ))
    }

@delegate:ResourceContentHash(-1_153_412_173)
internal val Res.string.roti_5: StringResource by lazy {
      StringResource("string:roti_5", "roti_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10002, 34),
      ))
    }

@delegate:ResourceContentHash(1_431_889_005)
internal val Res.string.roti_answer_prompt: StringResource by lazy {
      StringResource("string:roti_answer_prompt", "roti_answer_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10037, 90),
      ))
    }

@delegate:ResourceContentHash(-821_138_790)
internal val Res.string.roti_average: StringResource by lazy {
      StringResource("string:roti_average", "roti_average", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10128, 40),
      ))
    }

@delegate:ResourceContentHash(916_727_200)
internal val Res.string.roti_vote_single: StringResource by lazy {
      StringResource("string:roti_vote_single", "roti_vote_single", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10169, 36),
      ))
    }

@delegate:ResourceContentHash(-1_911_394_486)
internal val Res.string.roti_votes: StringResource by lazy {
      StringResource("string:roti_votes", "roti_votes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10206, 34),
      ))
    }

@delegate:ResourceContentHash(-1_655_943_125)
internal val Res.string.save_participant_names_action: StringResource by lazy {
      StringResource("string:save_participant_names_action", "save_participant_names_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10241, 65),
      ))
    }

@delegate:ResourceContentHash(1_078_690_750)
internal val Res.string.session_code_heading: StringResource by lazy {
      StringResource("string:session_code_heading", "session_code_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10307, 44),
      ))
    }

@delegate:ResourceContentHash(1_078_690_750)
internal val Res.string.session_code_label: StringResource by lazy {
      StringResource("string:session_code_label", "session_code_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10352, 42),
      ))
    }

@delegate:ResourceContentHash(2_138_104_790)
internal val Res.string.session_code_placeholder: StringResource by lazy {
      StringResource("string:session_code_placeholder", "session_code_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10395, 56),
      ))
    }

@delegate:ResourceContentHash(355_020_491)
internal val Res.string.session_ended_action: StringResource by lazy {
      StringResource("string:session_ended_action", "session_ended_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10452, 56),
      ))
    }

@delegate:ResourceContentHash(915_682_562)
internal val Res.string.session_ended_dialog_action: StringResource by lazy {
      StringResource("string:session_ended_dialog_action", "session_ended_dialog_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10509, 47),
      ))
    }

@delegate:ResourceContentHash(132_042_798)
internal val Res.string.session_ended_message: StringResource by lazy {
      StringResource("string:session_ended_message", "session_ended_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10557, 81),
      ))
    }

@delegate:ResourceContentHash(2_009_424_107)
internal val Res.string.session_ended_title: StringResource by lazy {
      StringResource("string:session_ended_title", "session_ended_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10639, 47),
      ))
    }

@delegate:ResourceContentHash(-1_780_624_284)
internal val Res.string.share_retro_action: StringResource by lazy {
      StringResource("string:share_retro_action", "share_retro_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10687, 46),
      ))
    }

@delegate:ResourceContentHash(714_617_231)
internal val Res.string.share_retro_dialog_action: StringResource by lazy {
      StringResource("string:share_retro_dialog_action", "share_retro_dialog_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10734, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("error_rate_limited", Res.string.error_rate_limited)
  map.put("error_session_not_found", Res.string.error_session_not_found)
  map.put("finish_retro_action", Res.string.finish_retro_action)
  map.put("invitation_link_label", Res.string.invitation_link_label)
  map.put("invitation_link_supporting_text", Res.string.invitation_link_supporting_text)
  map.put("invitation_share_action", Res.string.invitation_share_action)
  map.put("invitation_share_code_option", Res.string.invitation_share_code_option)
  map.put("invitation_share_link_option", Res.string.invitation_share_link_option)
  map.put("invitation_share_title", Res.string.invitation_share_title)
  map.put("join_action", Res.string.join_action)
  map.put("join_hint", Res.string.join_hint)
  map.put("join_loading", Res.string.join_loading)
  map.put("join_subtitle", Res.string.join_subtitle)
  map.put("join_title", Res.string.join_title)
  map.put("leave_action", Res.string.leave_action)
  map.put("lobby_connecting", Res.string.lobby_connecting)
  map.put("lobby_waiting", Res.string.lobby_waiting)
  map.put("moderator_badge", Res.string.moderator_badge)
  map.put("moderator_lobby_title", Res.string.moderator_lobby_title)
  map.put("moderator_question_title", Res.string.moderator_question_title)
  map.put("moderator_summary_title", Res.string.moderator_summary_title)
  map.put("name_option_occupied", Res.string.name_option_occupied)
  map.put("name_options_loading", Res.string.name_options_loading)
  map.put("name_selection_heading", Res.string.name_selection_heading)
  map.put("next_question_action", Res.string.next_question_action)
  map.put("no_answer_action", Res.string.no_answer_action)
  map.put("no_answer_status", Res.string.no_answer_status)
  map.put("no_answers", Res.string.no_answers)
  map.put("no_more_answers_action", Res.string.no_more_answers_action)
  map.put("no_more_answers_status", Res.string.no_more_answers_status)
  map.put("open_status", Res.string.open_status)
  map.put("own_answers_title", Res.string.own_answers_title)
  map.put("participant_answer_count", Res.string.participant_answer_count)
  map.put("participant_count", Res.string.participant_count)
  map.put("participant_lobby_title", Res.string.participant_lobby_title)
  map.put("participant_names_label", Res.string.participant_names_label)
  map.put("participant_names_supporting_text", Res.string.participant_names_supporting_text)
  map.put("participant_question_title", Res.string.participant_question_title)
  map.put("question_answer_visibility_label", Res.string.question_answer_visibility_label)
  map.put("question_label", Res.string.question_label)
  map.put("question_placeholder", Res.string.question_placeholder)
  map.put("question_progress", Res.string.question_progress)
  map.put("question_timer_enabled_label", Res.string.question_timer_enabled_label)
  map.put("question_timer_label", Res.string.question_timer_label)
  map.put("question_timer_supporting_text", Res.string.question_timer_supporting_text)
  map.put("question_widget_action_items", Res.string.question_widget_action_items)
  map.put("question_widget_battery", Res.string.question_widget_battery)
  map.put("question_widget_daki", Res.string.question_widget_daki)
  map.put("question_widget_dot_voting", Res.string.question_widget_dot_voting)
  map.put("question_widget_four_l", Res.string.question_widget_four_l)
  map.put("question_widget_hot_air_balloon", Res.string.question_widget_hot_air_balloon)
  map.put("question_widget_kalm", Res.string.question_widget_kalm)
  map.put("question_widget_label", Res.string.question_widget_label)
  map.put("question_widget_mad_sad_glad", Res.string.question_widget_mad_sad_glad)
  map.put("question_widget_roti", Res.string.question_widget_roti)
  map.put("question_widget_sailboat", Res.string.question_widget_sailboat)
  map.put("question_widget_speedcar", Res.string.question_widget_speedcar)
  map.put("question_widget_starfish", Res.string.question_widget_starfish)
  map.put("question_widget_team_radar", Res.string.question_widget_team_radar)
  map.put("question_widget_text", Res.string.question_widget_text)
  map.put("question_widget_weather", Res.string.question_widget_weather)
  map.put("radar_answer_count", Res.string.radar_answer_count)
  map.put("radar_answer_prompt", Res.string.radar_answer_prompt)
  map.put("radar_answer_single", Res.string.radar_answer_single)
  map.put("radar_collaboration", Res.string.radar_collaboration)
  map.put("radar_collaboration_hint", Res.string.radar_collaboration_hint)
  map.put("radar_focus", Res.string.radar_focus)
  map.put("radar_focus_hint", Res.string.radar_focus_hint)
  map.put("radar_fun", Res.string.radar_fun)
  map.put("radar_fun_hint", Res.string.radar_fun_hint)
  map.put("radar_learning", Res.string.radar_learning)
  map.put("radar_learning_hint", Res.string.radar_learning_hint)
  map.put("radar_quality", Res.string.radar_quality)
  map.put("radar_quality_hint", Res.string.radar_quality_hint)
  map.put("radar_score_description", Res.string.radar_score_description)
  map.put("radar_speed", Res.string.radar_speed)
  map.put("radar_speed_hint", Res.string.radar_speed_hint)
  map.put("registered_participants", Res.string.registered_participants)
  map.put("retro_finished", Res.string.retro_finished)
  map.put("reveal_answers_action", Res.string.reveal_answers_action)
  map.put("revealed_answers_title", Res.string.revealed_answers_title)
  map.put("roti_1", Res.string.roti_1)
  map.put("roti_2", Res.string.roti_2)
  map.put("roti_3", Res.string.roti_3)
  map.put("roti_4", Res.string.roti_4)
  map.put("roti_5", Res.string.roti_5)
  map.put("roti_answer_prompt", Res.string.roti_answer_prompt)
  map.put("roti_average", Res.string.roti_average)
  map.put("roti_vote_single", Res.string.roti_vote_single)
  map.put("roti_votes", Res.string.roti_votes)
  map.put("save_participant_names_action", Res.string.save_participant_names_action)
  map.put("session_code_heading", Res.string.session_code_heading)
  map.put("session_code_label", Res.string.session_code_label)
  map.put("session_code_placeholder", Res.string.session_code_placeholder)
  map.put("session_ended_action", Res.string.session_ended_action)
  map.put("session_ended_dialog_action", Res.string.session_ended_dialog_action)
  map.put("session_ended_message", Res.string.session_ended_message)
  map.put("session_ended_title", Res.string.session_ended_title)
  map.put("share_retro_action", Res.string.share_retro_action)
  map.put("share_retro_dialog_action", Res.string.share_retro_dialog_action)
}
